import { ConservationProject } from '@/api/rest/resources/conservation';

import { useConservationFile } from './useConservation';
import { useConservationProjectName } from './useConservationProjectName';

export const useProject = (id?: string) => {
  const projectName = useConservationProjectName(id);

  if (!projectName) {
    throw new Error('Conservation project name not found');
  }

  return useConservationFile<ConservationProject>({
    projectName,
    fileName: 'project.json',
  });
};
